import React from "react";
import { FacilityOrderEditTemplateCsv } from "themes/application/facility-order/pages";
import { observer } from "mobx-react";
import { FacilityOrderEditCsvViewStore } from "application/facility-order/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new FacilityOrderEditCsvViewStore(rootStore), "facilityOrderEditCsvViewStore")
@observer
class FacilityOrderEditCsv extends React.Component {
	render() {
		return <FacilityOrderEditTemplateCsv {...this.props} />;
	}
}

export default FacilityOrderEditCsv;